
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Innovacabforout() {



  const cardData =
  {
    keyword: 'Innova Cab for Outstation in Pune',
    heading: 'SHREE Tours & Travels: Innova Cab for Outstation in Pune   ',
    headingDescription: 'SHREE Tours & Travels offers Innova Cab for outstation in Pune, providing a spacious and comfortable travel experience for families, groups and corporate trips. Whether you are traveling to Mumbai, Mahabaleshwar, Shirdi, Nashik, Goa, or any other destination, our well-maintained Toyota Innova ensures a smooth and hassle-free journey. With professional drivers, on-time service, ample luggage space and affordable pricing, we make outstation travel convenient and enjoyable. Choose SHREE Tours & Travels for the best Innova rental service in Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in Pune, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand structure features intricate wooden architecture, massive gates and the famous 'Delhi Darwaza.' It is surrounded by gardens and fountains, making it a great spot for history enthusiasts. The light and sound show in the evening narrates the fort's rich history, adding to the experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is an architectural masterpiece and a symbol of India's freedom struggle. It served as a prison for Mahatma Gandhi and other freedom fighters during the Quit India Movement. The palace features Italian arches, sprawling gardens and a museum housing personal belongings of Mahatma Gandhi, making it a must-visit for history and heritage lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop a hill, Sinhagad Fort is one of Pune’s most famous trekking destinations. This historic fortress, associated with the Maratha warrior Tanaji Malusare, offers breathtaking views of the Sahyadri mountains. Visitors can explore the ancient ruins, enjoy local delicacies like 'pithla bhakri,' and experience the fort’s rich history while trekking through its scenic trails."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganpati Temple is dedicated to Lord Ganesha. Known for its grand Ganesh idol adorned with gold ornaments, the temple attracts thousands of devotees daily. The temple’s annual Ganesh festival is a grand spectacle, featuring magnificent decorations, cultural performances and a spiritual ambiance."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A fascinating museum housing over 20,000 artifacts, the Raja Dinkar Kelkar Museum showcases a diverse collection of sculptures, paintings, musical instruments and everyday objects from India’s past. The museum is particularly known for its replica of the Mastani Mahal, which provides a glimpse into the royal lifestyle of the Peshwas."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Carved out of a single rock in the 8th century, the Pataleshwar Cave Temple is dedicated to Lord Shiva. This ancient temple, featuring massive stone pillars and intricate carvings, is a peaceful retreat amidst Pune’s bustling city life. The temple’s unique architecture and serene atmosphere make it a hidden gem for history and spirituality seekers."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a beautiful artificial lake, ideal for nature lovers and bird watchers. Surrounded by lush greenery, the lake serves as a habitat for various migratory birds. The walking track along the lake makes it a perfect spot for morning walks, photography and peaceful relaxation away from the city’s hustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual center promoting meditation and wellness. Visitors can experience a range of meditation techniques, yoga sessions and rejuvenation therapies. The ashram's lush gardens, serene atmosphere and international community make it a unique place for self-discovery and relaxation."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal is a historic site closely associated with Chhatrapati Shivaji Maharaj, as it was his childhood residence. Though rebuilt, the palace features paintings and exhibits depicting Shivaji’s life and achievements. The site is of great historical importance and offers insights into the Maratha legacy."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Situated on the outskirts of Pune, Khadakwasla Dam is a popular picnic spot offering scenic views and a refreshing escape. The dam is a great place for photography, evening walks and enjoying street food like corn and chai. The nearby Sinhagad Fort and Panshet Dam make it a perfect getaway for adventure seekers and nature lovers."
    }
],  
    
            
"services": [
    {
      "name": "Innova Outstation Cab Pune",
      "description": "Rent an Innova for your outstation trips from Pune. Known for its spacious interiors and reliable performance, the Innova is perfect for long-distance journeys, offering comfort and convenience for families or groups."
    },
    {
      "name": "Rent Innova for Outstation Pune",
      "description": "Book an Innova for your outstation trips from Pune. Whether you're traveling solo, with family, or as a group, the Innova provides a smooth ride, ample space and a comfortable journey for long distances."
    },
    {
      "name": "Affordable Innova Outstation Taxi Pune",
      "description": "Looking for an affordable yet comfortable outstation taxi? Rent an Innova for your travel needs from Pune. Get the best value for your money with a spacious vehicle that is perfect for family or group trips."
    },
    {
      "name": "Book Innova for Long-Distance Travel from Pune",
      "description": "Planning a long-distance trip from Pune? Rent an Innova for a comfortable and spacious ride. Ideal for both business and leisure travel, this vehicle ensures a smooth journey no matter the distance."
    },
    {
      "name": "Private Innova Taxi for Outstation from Pune",
      "description": "Book a private Innova taxi for your outstation travel from Pune. Enjoy a personalized and comfortable experience, with an experienced driver who will ensure a smooth, hassle-free journey."
    },
    {
      "name": "Pune to Outstation in Innova",
      "description": "Travel from Pune to your desired outstation destination in an Innova. With its luxury features, roomy interiors and reliable performance, it’s the perfect car for both short and long trips."
    },
    {
      "name": "Innova for Group Travel Outstation",
      "description": "Rent an Innova for group outstation travel from Pune. The vehicle can comfortably accommodate larger groups, making it the ideal choice for family getaways, group tours, or business travel."
    },
    {
      "name": "Innova Hire for Family Outstation Trip Pune",
      "description": "Travel with your family in comfort by hiring an Innova for your outstation trip from Pune. With enough space for everyone, your family can enjoy a relaxing journey with plenty of room for luggage."
    },
    {
      "name": "Affordable Innova Cab Rental Pune",
      "description": "Get an affordable Innova rental for your outstation trips from Pune. Whether you’re going on a short weekend getaway or a long vacation, enjoy comfort and affordability without compromising on quality."
    },
    {
      "name": "Luxury Innova Outstation Hire Pune",
      "description": "Experience luxury travel with an Innova outstation hire from Pune. Enjoy plush interiors, smooth performance and the comfort of a premium ride for both short and long trips."
    },
    {
      "name": "Book Innova Cab for Weekend Outstation Travel",
      "description": "Plan your weekend getaway with an Innova Cab for outstation travel from Pune. Whether it's a beach retreat, hill station visit, or a city tour, the Innova is the perfect vehicle for a comfortable, enjoyable trip."
    },
    {
      "name": "Pune to Outstation Travel by Innova",
      "description": "Book an Innova for your Pune to outstation travel. With its spacious seats, climate control and ample boot space, the Innova is ideal for long-distance travel, providing a luxurious ride for your journey."
    }
  ],
  "tableData": [
    ["- Innova Outstation Cab Pune", "- Rent Innova for Outstation Pune"],
    ["- Affordable Innova Outstation Taxi Pune", "- Book Innova for Long-Distance Travel from Pune"],
    ["- Private Innova Taxi for Outstation from Pune", "- Pune to Outstation in Innova"],
    ["- Innova for Group Travel Outstation", "- Innova Hire for Family Outstation Trip Pune"],
    ["- Affordable Innova Cab Rental Pune", "- Luxury Innova Outstation Hire Pune"],
    ["- Book Innova Cab for Weekend Outstation Travel", "- Pune to Outstation Travel by Innova"]
  ],

  whychoose: [
    {
      "WhyChooseheading": "Spacious and Comfortable Travel",
      "WhyChoosedescription": "The Toyota Innova is known for its spacious and comfortable interiors, making it the perfect choice for long outstation journeys. With ample legroom, comfortable seating and a smooth ride, the Innova ensures a relaxed travel experience for you and your companions on every trip from Pune to outstation destinations."
    },
    {
      "WhyChooseheading": "Ideal for Family and Group Travel",
      "WhyChoosedescription": "With seating for up to seven passengers, the Innova is an excellent choice for family or group travel. Whether you're going on a vacation, a family reunion, or a business trip, this versatile vehicle offers the comfort and space required for a pleasant and enjoyable ride."
    },
    {
      "WhyChooseheading": "Well-Maintained and Reliable Vehicles",
      "WhyChoosedescription": "All our Toyota Innova vehicles are regularly maintained and thoroughly inspected to ensure they are in top condition for your outstation journey. We prioritize safety, comfort and reliability, ensuring that each vehicle meets our high standards before it hits the road."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our professional drivers are highly experienced, knowledgeable of the best routes and trained to ensure safe and smooth journeys. They focus on providing a comfortable, stress-free ride and are committed to punctuality and customer satisfaction, making your outstation travel hassle-free."
    },
    {
      "WhyChooseheading": "Affordable Outstation Rental Packages",
      "WhyChoosedescription": "We offer competitive and affordable pricing for outstation trips in the Toyota Innova. Our rental packages are designed to provide great value, with transparent pricing and no hidden fees. Whether you're traveling for a day or multiple days, we offer flexible packages that suit your needs and budget."
    },
    {
      "WhyChooseheading": "Seamless Booking Process",
      "WhyChoosedescription": "Booking an Innova for your outstation trip with SHREE Tours & Travels is easy and convenient. You can book online through our user-friendly platform or contact our customer support team for personalized assistance. We ensure a smooth and hassle-free booking experience every time."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We provide 24/7 availability for outstation Innova rentals from Pune. No matter the time of day or night, we’re ready to serve your transportation needs. Whether it’s an early morning departure or a late-night return, we are here to accommodate your schedule."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "Customer satisfaction is our top priority. At SHREE Tours & Travels, we ensure that every Innova rental provides a comfortable, safe and enjoyable experience. Our commitment to quality service and punctuality means you can travel with confidence, knowing your journey will be hassle-free."
    }
  ]
  
  
  
  
  

  
  



        
  }
  const faqData = [
    {
        question: "How can I book an Innova Cab for outstation from Pune?",
        answer: "You can easily book an Innova Cab for outstation from Pune through our website or by contacting our customer service for assistance."
    },
    {
        question: "What is the rental rate for an Innova Cab for outstation from Pune?",
        answer: "The rental rate for an Innova Cab for outstation varies depending on the destination, duration and type of trip. Please contact us for detailed pricing information."
    },
    {
        question: "Is the rental rate for the Innova Cab inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. We provide detailed pricing information during the booking process."
    },
    {
        question: "Can I book an Innova Cab for a one-way outstation trip from Pune?",
        answer: "Yes, we offer one-way rental options for the Innova Cab for outstation trips from Pune to various destinations."
    },
    {
        question: "Do you provide drivers with the Innova Cab for outstation trips from Pune?",
        answer: "Yes, all our Innova Cabs come with experienced drivers who are familiar with long-distance routes to ensure a smooth and safe journey."
    },
    {
        question: "What is your cancellation policy for Innova bookings for outstation from Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for renting an Innova Cab for outstation from Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the Innova vehicles insured for safety during outstation trips from Pune?",
        answer: "Yes, all our Innova vehicles are fully insured for your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my Innova rental for outstation from Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking an Innova Cab for outstation from Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I hired an Innova Cab from SHREE Tours & Travels for an outstation trip from Pune. The car was spacious and well-maintained and the driver was very professional and courteous.',
        name: 'Mr. Sanjay Mehta',
    },
    {
        text: 'The Innova Cab service from SHREE Tours & Travels for my outstation trip was fantastic. The vehicle was comfortable and perfect for long distances and the journey was smooth throughout.',
        name: 'Miss. Priya Nair',
    }
];
















  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Rent an Innova for outstation travel from Pune. We offer affordable and comfortable Innova Cabs for long-distance trips, group travel, family outings, corporate travel and weekend getaways. Call +91 9594917913 to book an Innova for your next trip!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/innova-outstation.jpg",
    "https://shreetoursandtravels.in/img/innova-group-travel.jpg"
  ],
  "priceRange": "₹5000 - ₹12000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/innova-outstation-pune",
    "priceCurrency": "INR",
    "price": 6000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.8,
    "reviewCount": 1200
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Rajesh Kamat"
      },
      "datePublished": "2024-10-03",
      "reviewBody": "Booked an Innova for a family trip to Shirdi. The vehicle was clean and spacious and the driver was professional. Highly recommended!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Rina Deshpande"
      },
      "datePublished": "2024-11-21",
      "reviewBody": "We used the Innova for a group trip to Mahabaleshwar. Comfortable ride with good service. Made the trip stress-free!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Innova Outstation Hire in Pune",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/innova-outstation-pune"
  },
  "keywords": "Innova Outstation Cab Pune, Rent Innova for Outstation Pune, Affordable Innova Outstation Taxi Pune, Book Innova for Long-Distance Travel from Pune, Private Innova Taxi for Outstation from Pune, Pune to Outstation in Innova, Innova for Group Travel Outstation, Innova Hire for Family Outstation Trip Pune, Affordable Innova Cab Rental Pune, Luxury Innova Outstation Hire Pune, Book Innova Cab for Weekend Outstation Travel, Pune to Outstation Travel by Innova"
};



  return (
    <div>
    <GoogleAnalytics/>
<Helmet>
  <title>Innova Outstation Hire in Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Rent an Innova for outstation travel from Pune. We offer affordable and comfortable Innova Cabs for long-distance trips, group travel, family outings, corporate travel and weekend getaways. Call +91 9594917913 to book an Innova for your next trip!" />
  <meta name="keywords" content="Innova Outstation Cab Pune, Rent Innova for Outstation Pune, Affordable Innova Outstation Taxi Pune, Book Innova for Long-Distance Travel from Pune, Private Innova Taxi for Outstation from Pune, Pune to Outstation in Innova, Innova for Group Travel Outstation, Innova Hire for Family Outstation Trip Pune, Affordable Innova Cab Rental Pune, Luxury Innova Outstation Hire Pune, Book Innova Cab for Weekend Outstation Travel, Pune to Outstation Travel by Innova" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>
    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/27.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Innovacabforout;